<template>
	<div>
		<mainDiv/>
	</div>
</template>

<script>
	import mainDiv from '@/components/detail/main'
	
	export default{
		components:{
			mainDiv
		},
		created(){
			this.$emit('headerCur',4);
		}
	}
</script>

<style>
</style>
